"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Protocol = exports.CSharpLanguage = exports.Language = exports.Metadata = void 0;
const codegen_1 = require("@azure-tools/codegen");
const tag_1 = require("../../tag");
const languages_1 = require("./languages");
const protocols_1 = require("./protocols");
class Metadata extends codegen_1.Initializer {
    constructor(objectInitializer) {
        super();
        this.language = (0, tag_1.SetType)(languages_1.Languages, {
            default: {
                name: "",
                description: "",
            },
        });
        this.protocol = (0, tag_1.SetType)(protocols_1.Protocols, {});
        this.apply(objectInitializer);
    }
}
exports.Metadata = Metadata;
class Language {
}
exports.Language = Language;
class CSharpLanguage {
}
exports.CSharpLanguage = CSharpLanguage;
class Protocol extends codegen_1.Initializer {
    constructor(objectInitializer) {
        super();
        this.apply(objectInitializer);
    }
}
exports.Protocol = Protocol;
//# sourceMappingURL=metadata.js.map